import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'react-bootstrap';
import i18n from 'ar-i18n';

class BudgetPopover extends Component {

    static propTypes = {
        recommendedBudget: PropTypes.number
    }

    render() {
        const { recommendedBudget } = this.props;
        return (
            <div>
                <Popover id='popover-positioned-right' placement='right' { ...this.props }>
                    <p>
                        { i18n.gettext('The optimal daily budget is') }<strong>{ i18n.numeral.formatCurrency(recommendedBudget) }</strong>{ i18n.gettext('for your campaign.') }
                    </p>
                    <p>
                        { i18n.gettext('*Please, refer') }<a className='red-link' href='//www.rakuten.co.jp/shops/manual/navi/promotion/07_r003.html#link-a' target='_blank'>{ i18n.gettext('here') }</a>{ i18n.gettext('to find out why it is important to serve ads throughout the whole day.') }
                    </p>
                    <p>
                        { i18n.gettext('*The optimal daily budget is calculated based on the amount of daily unique users visitng your page.') }
                    </p>
                </Popover>
            </div>
        );
    }
}

export default BudgetPopover;
